app.directive('smsVerification', [
    '$state', '$ionicHistory', '$ionicLoading', '$ionicTabsDelegate', '$ionicModal',
    'LocaleService', 'Storage', '$timeout', 'UserService', 'Utils', 'Validator', 'API',
    'ErrorService', 'constants', 'LocalStorage',
    function ($state, $ionicHistory, $ionicLoading, $ionicTabsDelegate, $ionicModal,
              LocaleService, Storage, $timeout, UserService, Utils, Validator, API,
              ErrorService, Const, LocalStorage) {
        return {
            restrict: 'E',
            link: function (scope, element) {

                var expire = 5 * 60 * 1000;

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });

                scope.validator = Validator.getPattern;

                scope.user = UserService.get();

                if (!Storage.get('smsVerification') || (Storage.get('smsVerification') && scope.user.smsVerified)) {
                    return;
                }
                $ionicHistory && $ionicHistory.clearHistory();
                scope.sms = {
                    phone: '',
                    code: '',
                    codeSent: false
                };

                var modalDefaults = {
                    isError: false,
                    textTitle: '',
                    textContent: '',
                    state: false,
                    isProcess: false
                };

                scope.modal = angular.copy(modalDefaults);

                function isNotExpired(data) {
                    return (Date.now() - data.expire) <= expire;
                }

                //get previous state from cookie
                var prevState = LocalStorage.get('smsVerification');

                if (prevState && isNotExpired(JSON.parse(prevState))) {
                    scope.sms = JSON.parse(prevState).data;
                } else {
                    scope.sms.phone = scope.user.phone;
                }

                $ionicModal.fromTemplateUrl('templates/directives/popup-sms.html', {
                    scope: scope,
                    hardwareBackButtonClose: false,
                    animation: 'slide-in-up'
                }).then(function (modal) {
                    scope.modal = modal;
                    scope.modal.show();
                });

                scope.close = function () {
                    scope.modal.hide();
                };

                scope.sendPhone = function (form) {
                    Utils.formRevalidate(form);
                    if (!form.$valid) return;

                    //reset code
                    scope.sms.code = '';
                    scope.sms.codeSent = false;

                    var request = {
                        phone: scope.sms.phone
                    };

                    $ionicLoading.show();
                    return API.smsVerificationPhone(request)
                        .then(checkResponse)
                        .then(function (response) {
                            $ionicLoading.hide();
                            scope.sms.codeSent = true;
                            LocalStorage.set('smsVerification', JSON.stringify({
                                data: scope.sms,
                                expire: Date.now() + expire
                            }))
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            scope.modal.isError = true;
                            scope.modal.isProcess = false;
                            scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                            scope.modal.textContent = LocaleService.translation.messages.smsPhoneFailed;
                            scope.modal.actionText = LocaleService.translation.try_again;
                            scope.modal.state = true;
                        })
                };

                scope.sendCode = function (form) {
                    Utils.formRevalidate(form);
                    if (!form.$valid) return;

                    var request = {
                        phone: scope.sms.phone,
                        code: scope.sms.code
                    };

                    $ionicLoading.show();
                    return API.smsVerificationCode(request)
                        .then(checkResponse)
                        .then(function (response) {
                            $ionicLoading.hide();
                            scope.user.smsVerified = true;
                            LocalStorage.remove('smsVerification');
                            scope.modal.hide();
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            scope.modal.isError = true;
                            scope.modal.isProcess = false;
                            scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                            scope.modal.textContent = LocaleService.translation.messages.smsVerificationFailed;
                            scope.modal.actionText = LocaleService.translation.try_again;
                            scope.modal.state = true;
                        })
                };


                function checkResponse(response, request) {
                    if (response.status === 0) {
                        throw new ErrorService({
                            source: 'AppController',
                            type: Const.error.type.VALIDATION,
                            severity: 'warning',
                            code: response.code || 'general_error',
                            data: {
                                request: request,
                                response: response
                            }
                        })
                    }
                    return response;
                };

                element.on('$destroy', function () {
                    $ionicHistory && $ionicHistory.clearHistory();
                    scope.modal && scope.modal.remove();
                    scope.modal = null;
                    scope.sms = null;
                });
            }
        }
    }]);